import React from 'react'
import styled from '@emotion/styled'
import { Icon } from 'antd'
import { colors } from 'style/theme'

const StatMiniCounters = styled.div({
	display: 'grid',
	gridTemplateRows: 'repeat(4, 1fr)',
	gridGap: 5
})
const StatMiniCounter = styled.div({
	display: 'flex',
	alignItems: 'center',
	fontSize: 18,
	label: {
		fontSize: 11,
		color: colors.brandGray,
		marginLeft: 8,
		width: 90
	},
	strong: {
		fontSize: 14
	}
})

export const MiniCounters = ({ data }) => {
	return (
		<StatMiniCounters>
			<StatMiniCounter>
				<Icon type="exclamation-circle" style={{ color: colors.error.color }} />
				<label>ERROR</label>
				<strong>100</strong>
			</StatMiniCounter>
			<StatMiniCounter>
				<Icon type="warning" style={{ color: colors.warning.color }} />
				<label>REGRESSION</label>
				<strong>100</strong>
			</StatMiniCounter>
			<StatMiniCounter>
				<Icon type="stop" style={{ color: colors.iconNoChange.color }}/>
				<label>NO CHANGE</label>
				<strong>100</strong>
			</StatMiniCounter>
			<StatMiniCounter>
				<Icon
					type="issues-close" style={{ color: colors.success.color }}
				/>
				<label>FIXED</label>
				<strong>100</strong>
			</StatMiniCounter>
		</StatMiniCounters>
	)
}
